import React from "react";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { GreenButton } from "../_helpers/customMUI";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
const componentStyles = () => ({
  chatWrapper: {
    backgroundColor: "rgba(109, 169, 179, 0.1)",
    padding: 10,
    borderRadius: 5,
    fontSize: "0.9rem",
    color: "#585858",
    fontWeight: "medium",
    position: "relative",
    textAlign: "left",
    width: 300
  },
  chatArrow: {
    width: 0,
    height: 0,
    borderLeft: "8px solid transparent",
    borderRight: "8px solid transparent",
    borderBottom: "8px solid rgba(109, 169, 179, 0.1)",
    position: "absolute",
    left: 140,
    top: "-7px"
  }
});
const StyledRoot = styled("div")(({
  theme
}) => ({
  display: "contents",
  ...Object.entries(componentStyles(theme)).reduce((acc, [className, style]) => ({
    ...acc,
    [`& .${className}, &.${className}`]: style
  }), {})
}));
function ErrorFallback({
  error,
  resetErrorBoundary
}) {
  console.error(error);
  // Call resetErrorBoundary() to reset the error boundary and retry the render.
  const {
    t
  } = useTranslation();
  return <StyledRoot>
    <div role="alert">
      <Grid container style={{
        paddingTop: 100
      }} sx={{
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
      }}>
        <Grid style={{
          height: 220,
          width: 220,
          backgroundColor: "rgba(109, 169, 179, 0.3)",
          borderRadius: "50%",
          boxShadow: "1px 1px 2px 1px rgba(89, 89, 89, 0.5)"
        }}>
          <img src={`../../src/_images/Lili_Confused.gif`} alt="Loading..." style={{
            width: 220,
            height: 220,
            borderRadius: "51%"
          }} />
        </Grid>
        <Grid style={{
          paddingTop: 8
        }}>
          <div className={"chatWrapper"}>
            <div className={"chatArrow"} />
            <Typography>{t("help.errorMessage")}</Typography>
          </div>
        </Grid>
        <Grid style={{
          paddingTop: 12
        }}>
          <GreenButton size="small" variant="contained" onClick={resetErrorBoundary}>
            {t("help.tryAgain")}
          </GreenButton>
        </Grid>
      </Grid>
    </div>
  
    </StyledRoot>;
}
ErrorFallback.propTypes = {
  error: PropTypes.object,
  resetErrorBoundary: PropTypes.func
};
export default ErrorFallback;
